'use client'

export default function GlobalError({
  error,
  reset,
}) {
  return (
    <html>
      <body>
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8f9fa',
          fontFamily: 'Arial, sans-serif',
          padding: '20px'
        }}>
          <div style={{
            textAlign: 'center',
            maxWidth: '600px'
          }}>
            <h1 style={{
              fontSize: '4rem',
              fontWeight: 'bold',
              color: '#dc3545',
              marginBottom: '1rem'
            }}>
              500
            </h1>
            
            <h2 style={{
              fontSize: '1.5rem',
              color: '#343a40',
              marginBottom: '1rem'
            }}>
              Service Temporarily Unavailable
            </h2>
            
            <p style={{
              fontSize: '1rem',
              color: '#6c757d',
              marginBottom: '2rem',
              lineHeight: '1.5'
            }}>
              We&apos;re experiencing technical difficulties. Please try again in a few minutes.
            </p>
            
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button 
                onClick={() => reset()}
                style={{
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  textDecoration: 'none'
                }}
              >
                Try Again
              </button>
              
              <a 
                href="/home"
                style={{
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
              >
                Go Home
              </a>
            </div>
          </div>
        </div>
      </body>
    </html>
  )
}